@singleton()
export class RouterProvider {
  getRouter() {
    return useRouter();
  }
}
